import { User } from '@/models/user/user';
import { HttpService } from './http-service';

export class UsersService extends HttpService {
    protected getResourceUrl() { return 'api/users' };
    protected getResponseMapper() { return User.parseJson }

    getById(id: number): Promise<User> {
        return this.get({
            resourceId: id,
            responseMapper: User.parseJson
        })
    }

    getUsersPage(page: number, pageSize: number): Promise<User> {
        return this.get({
            params: {
                limit: pageSize,
                skip: (page - 1) * pageSize
            },
            responseMapper: User.parseJson
        })
    }

    getTotalCount(): Promise<number> {
        return this.get({
            path: '/total'
        })
    }

    createUser(user: User) {
        return this.post({
            data: {
                username: user.username,
                role: user.role,
                mustChangePassword: user.mustChangePassword,
                password: user.password
            }
        })
    }

    updateUser(user: User) {
        const data: any = {
            username: user.username,
            role: user.role,
            mustChangePassword: user.mustChangePassword
        }

        // Only include password if it's being changed
        if (user.password) {
            data.password = user.password
        }

        return this.update({
            resourceId: user.id,
            data
        })
    }

    deleteUser(params: { resourceId: number }) {
        return this.delete(params)
    }
}

export const usersService = new UsersService();
